import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowRightOnRectangle, HiOutlineLockClosed } from "react-icons/hi2";
import useAuth from "../hooks/useAuth";
import LanguageSwitcher from "../components/LanguageSwitcher";
import Button from "../ui/Button";

// Shown to an authenticated account whose role has no admin-panel access at
// all (e.g. an ordinary booking user). Roles that DO have panel access but
// open a page outside their permissions get the in-shell NotPermitted page.
function Unauthorized() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();

  const handleReturnToSignIn = async () => {
    if (isAuthenticated) {
      await logout();
    }
    navigate("/login", { replace: true });
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-surface-muted px-6 py-12">
      <div className="absolute end-6 top-6">
        <LanguageSwitcher compact />
      </div>
      <section className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-card sm:p-10">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-600">
          <HiOutlineLockClosed size={28} aria-hidden="true" />
        </span>
        <h1 className="mt-5 text-xl font-semibold tracking-tight text-slate-900">{t("shell.noPanelAccess.title")}</h1>
        <p className="mt-2 text-sm leading-6 text-slate-500">{t("shell.noPanelAccess.description")}</p>
        <Button className="mt-6" icon={HiOutlineArrowRightOnRectangle} onClick={handleReturnToSignIn}>
          {t("pages.unauthorized.returnToSignIn")}
        </Button>
      </section>
    </main>
  );
}

export default Unauthorized;
